'use client';

import { ArrowUpRight } from 'lucide-react';
import Button from '@/components/ui/Button';

interface ServiceCard {
  id: string;
  title: string;
  description: string;
}

export default function ServicesGrid() {
  const services: ServiceCard[] = [
    {
      id: 'guest-posts',
      title: 'Guest Posts',
      description: 'Feature articles on niche-specific sites with do-follow links.'
    },
    {
      id: 'niche-edits',
      title: 'Niche Edits',
      description: 'Insert backlinks into existing high-authority content.'
    },
    {
      id: 'authority-links',
      title: 'Authority Links',
      description: 'DA 50+ placements to boost credibility.'
    },
    {
      id: 'local-seo',
      title: 'Local SEO Links',
      description: 'Improve visibility in local search results.'
    },
    {
      id: 'custom-outreach',
      title: 'Custom Outreach',
      description: 'Tailored campaigns for unique industries.'
    }
  ];

  const handleServiceClick = (serviceId: string) => {
    // Optional: track clicks
    console.log(`Service clicked: ${serviceId}`);
  };

  const redirectToNicheBacklinks = () => {
    window.location.href = "https://top.nichebacklink.com/";
  };

  return (
    <section data-component-id="src/app/services/ServicesGrid.tsx:51:4" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="51" data-component-end-line="106" data-component-file="ServicesGrid.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20bg-white%20pb-16%20sm%3Apb-20%20md%3Apb-24%22%7D" className="w-full bg-white pb-16 sm:pb-20 md:pb-24">
      <div data-component-id="src/app/services/ServicesGrid.tsx:52:6" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="52" data-component-end-line="105" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1246px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="w-full max-w-[1246px] mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-id="src/app/services/ServicesGrid.tsx:53:8" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="53" data-component-end-line="85" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-3%20xl%3Agrid-cols-5%20gap-%5B18px%5D%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-[18px]">
          {services.map((service) => (
            <div data-component-id="src/app/services/ServicesGrid.tsx:55:12" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="55" data-component-end-line="83" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20bg-white%20border%20border-%5B%23c69632%5D%20rounded-%5B20px%5D%20overflow-hidden%20hover%3Ashadow-lg%20transition-all%20duration-300%20cursor-pointer%20group%22%7D"
              key={service.id}
              className="flex flex-col bg-white border border-[#c69632] rounded-[20px] overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer group"
              onClick={() => handleServiceClick(service.id)}
            >
              {/* Header */}
              <div data-component-id="src/app/services/ServicesGrid.tsx:61:14" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="61" data-component-end-line="65" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-%5B%23c9972a%5D%20px-3%20py-2.5%20shadow-%5B0px_3px_3px_%2300000028%5D%20rounded-t-%5B14px%5D%22%7D" className="bg-[#c9972a] px-3 py-2.5 shadow-[0px_3px_3px_#00000028] rounded-t-[14px]">
                <h3 data-component-id="src/app/services/ServicesGrid.tsx:62:16" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="62" data-component-end-line="64" data-component-file="ServicesGrid.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B18px%5D%20sm%3Atext-%5B20px%5D%20md%3Atext-%5B22px%5D%20font-normal%20leading-%5B31px%5D%20text-white%20text-center%22%7D" className="text-[18px] sm:text-[20px] md:text-[22px] font-normal leading-[31px] text-white text-center">
                  {service.title}
                </h3>
              </div>

              {/* Content with Arrow on Right */}
              <div data-component-id="src/app/services/ServicesGrid.tsx:68:14" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="68" data-component-end-line="82" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20p-5%20flex%20flex-row%20items-start%20justify-between%22%7D" className="flex-1 p-5 flex flex-row items-start justify-between">
                {/* Description on Left */}
                <p data-component-id="src/app/services/ServicesGrid.tsx:70:16" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="70" data-component-end-line="72" data-component-file="ServicesGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B14px%5D%20font-normal%20leading-%5B20px%5D%20text-%5B%23222222%5D%20text-left%20flex-1%20pr-3%22%7D" className="text-[14px] font-normal leading-[20px] text-[#222222] text-left flex-1 pr-3">
                  {service.description}
                </p>

                {/* Arrow Button on Right */}
                <button data-component-id="src/app/services/ServicesGrid.tsx:75:16" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="75" data-component-end-line="81" data-component-file="ServicesGrid.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-%5B30px%5D%20h-%5B30px%5D%20bg-%5B%23222222%5D%20rounded-full%20border%20border-%5B%23f7f8fb%5D%20flex%20items-center%20justify-center%20hover%3Abg-%5B%23333333%5D%20transition-transform%20duration-200%20group-hover%3Ascale-110%22%7D"
                  className="w-[30px] h-[30px] bg-[#222222] rounded-full border border-[#f7f8fb] flex items-center justify-center hover:bg-[#333333] transition-transform duration-200 group-hover:scale-110"
                  aria-label={`Learn more about ${service.title}`}
                  onClick={redirectToNicheBacklinks}
                >
                  <ArrowUpRight data-component-id="src/app/services/ServicesGrid.tsx:80:18" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="80" data-component-end-line="80" data-component-file="ServicesGrid.tsx" data-component-name="ArrowUpRight" data-component-content="%7B%22elementName%22%3A%22ArrowUpRight%22%2C%22className%22%3A%22w-6%20h-6%20text-white%22%7D" className="w-6 h-6 text-white" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Centered Button Below Grid */}
        <div data-component-id="src/app/services/ServicesGrid.tsx:88:8" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="88" data-component-end-line="104" data-component-file="ServicesGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-10%20flex%20justify-center%22%7D" className="mt-10 flex justify-center">
          <Button data-component-id="src/app/services/ServicesGrid.tsx:89:10" data-component-path="src/app/services/ServicesGrid.tsx" data-component-line="89" data-component-end-line="103" data-component-file="ServicesGrid.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%7D"
            text="Order Backlinks Now"
            text_color="text-[#222222]"
            border_border_radius="rounded-[36px]"
            padding="py-[14px] sm:py-[12px] md:py-[12px] px-[20px] sm:px-[26px] md:px-[30px]"
            fill_background="white"
            style={{
              border: "2px solid #c69632",
              fontFamily: '"BDO Grotesk", Sans-serif',
              fontSize: "18px",
              fontWeight: 400,
              lineHeight: "22px",
            }}
            onClick={redirectToNicheBacklinks}
          />
        </div>
      </div>
    </section>
  );
}
